import React, { useState, useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountryDetails, updateCountry, clearError, clearSuccess, clearLocationDetails } from '../../../redux/Slices/LocationsSlice';
import { showErrorToast, showSuccessToast } from '../../../shared/utils/toastHelper';

const EditCountry = () => {
    const { setTitle } = useTitle();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    
    const { countryDetails, loading, updating, error, success } = useSelector((state) => state.locations);

    const [formData, setFormData] = useState({
        name_ar: '',
        name_en: ''
    });

    useEffect(() => {
        setTitle('تعديل دولة');
        dispatch(fetchCountryDetails(id));
        
        return () => {
            dispatch(clearLocationDetails());
        };
    }, [setTitle, dispatch, id]);

    useEffect(() => {
        if (countryDetails) {
            setFormData({
                name_ar: countryDetails.name_ar || countryDetails.name || '',
                name_en: countryDetails.name_en || ''
            });
        }
    }, [countryDetails]);

    useEffect(() => {
        if (error) {
            showErrorToast(error);
            dispatch(clearError());
        }
        if (success) {
            showSuccessToast(success);
            dispatch(clearSuccess());
            navigate('/admin-locations/countries');
        }
    }, [error, success, dispatch, navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!formData.name_ar || !formData.name_en) {
            showErrorToast('الرجاء تعبئة جميع الحقول المطلوبة');
            return;
        }

        const submitData = new FormData();
        submitData.append('name_ar', formData.name_ar);
        submitData.append('name_en', formData.name_en);

        dispatch(updateCountry({ id, formData: submitData }));
    };

    if (loading && !countryDetails) {
        return (
            <div className="main_content text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 text-muted">جاري تحميل بيانات الدولة...</p>
            </div>
        );
    }

    return (
        <div className="main_content">
            <div className="dashboard-container">
                <div className="card shadow-lg border-0">
                    <div className="card-header bg-white pb-0 border-0">
                        <h4 className="mb-0">تعديل دولة #{id}</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">اسم الدولة (بالعربية) <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control hover-shadow transition-all"
                                        name="name_ar"
                                        value={formData.name_ar}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">اسم الدولة (بالإنجليزية) <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control hover-shadow transition-all"
                                        name="name_en"
                                        value={formData.name_en}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            </div>
                            
                            <div className="mt-4 d-flex gap-2">
                                <button 
                                    type="submit" 
                                    className="btn btn-primary px-4 py-2"
                                    disabled={updating}
                                >
                                    {updating ? 'جاري الحفظ...' : 'حفظ التعديلات'}
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-secondary px-4 py-2"
                                    onClick={() => navigate('/admin-locations/countries')}
                                    disabled={updating}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditCountry;
